import { render } from "./ClientesRecomendadosView.vue?vue&type=template&id=9f06ebf4"
import script from "./ClientesRecomendadosView.vue?vue&type=script&lang=js"
export * from "./ClientesRecomendadosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__